export const MIN_HOURS_BEFORE_TRIP_UPDATE = 4
export const OTHER_SELECTED_REASON_ID = '8'
